import IAHelpButton from "components/IaHelpButton/IaHelpButton.tsx";
import { AnimatePresence, motion } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useNavigate } from "react-router-dom";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import ToastAviso from "../../../components/Toast/ToastAviso/ToastAviso.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { emptyFiltroEmbarque } from "../../../contexts/ContextConstants.ts";
import { useEmbarqueDependencias } from "../../../contexts/EmbarqueDependenciasContext.tsx";
import { useFiltro } from "../../../contexts/FiltroContext.tsx";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import { useToast } from "../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import { formatDate } from "../../../core/utils/formatDate.ts";
import {
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../../core/utils/UtilityDates.ts";
import useOutsideClick from "../../../hooks/useOutsideClick.ts";
import { FiltroEmbarqueCompletoEnum } from "../../../models/FiltroEmbarqueCompleto.ts";
import {
	buscaSMP,
	insereSMP,
} from "../../../services/ModuloGerenciador/ApiSul.js";
import {
	cancelarEmbarque,
	comprovanteEntregue,
	definirMeiosPagamentos,
	deleteEmbarquePorId,
	getEmbarquePorId,
	getHistoricoEmbarque,
	getHistoricoFreteFiscal,
	getHistoricoPedido,
	getHistoricoStatus,
	lancarCheckin,
	lancarEmbalagem,
	lancarMercadoria,
	lancarStatus,
	lancarVeiculo,
} from "../../../services/ModuloGerenciador/Embarque";
import { getEmbarqueGeral } from "../../../services/ModuloGerenciador/Geral.ts";
import { vincularMotivoPorId } from "../../../services/ModuloGerenciador/MotivoOnTime.js";
import { getEmbarqueSearch } from "../../../services/ModuloGerenciador/Search";
import { buscarViagens } from "../../../services/ModuloGerenciador/Viagens.ts";
import CardSomatorio from "./components/CardSomatorio.tsx";
import FiltroViagens from "./components/FiltroViagens/FiltroViagens.tsx";
import ModaisEmbarque from "./components/ModaisEmbarque.tsx";
import TabelaEmbarqueVirtualizada from "./components/TabelaEmbarqueVirtualizada.tsx";
import {
	chavesFormatar,
	chavesRemover,
	colunasFreteFiscalEmbarque,
	colunasPedidoEmbarque,
	colunasStatusEmbarque,
} from "./constants/Embarque.const.ts";
import "./Embarque.css";

function Embarque() {
	const {
		filtroEmbarque,
		clearFiltros,
		setOrdenarPor,
		ordenarPor,
		isFiltroModified,
	} = useFiltro();
	const {
		contextoEmbarque,
		profile,
		dadosFilial,
		tabelaUsuario,
		hasRegra,
		isLoading: isContextLoading,
	} = useProfile();
	const { showToast } = useToast();
	const [isOpenDropdown, toggleDropdown, , refDropdown] = useOutsideClick();

	const {
		fetchStatus,
		fetchMotivos,
		fetchMercadorias,
		fetchEmbalagens,
		fetchVeiculos,
		buscandoEmbarqueEDependencias,
	} = useEmbarqueDependencias();

	const buscouEmbarques = useRef(false);
	const hasLoaded = useRef(false);

	const navigate = useNavigate();

	const [motivoId, setMotivoId] = useState();
	const [motivoId2, setMotivoId2] = useState();
	const [embarqueId, setEmbarqueId] = useState();
	const [embarqueIdSMP, setEmbarqueIdSMP] = useState();
	const [openCadastroFilial, setOpenCadastroFilial] = useState(false);
	const [openCadastroEmpresa, setOpenCadastroEmpresa] = useState(false);
	const [openCadastroVeiculo, setOpenCadastroVeiculo] = useState(false);
	const [openCadastroMercadoria, setOpenCadastroMercadoria] = useState(false);
	const [openCadastroEmbalagem, setOpenCadastroEmbalagem] = useState(false);
	const [openCadastroStatus, setOpenCadastroStatus] = useState(false);
	const [openCadastroMotivo, setOpenCadastroMotivo] = useState(false);
	const [openConfirmar, setOpenConfirmar] = useState(false);
	const [openModalInformacoes, setOpenModalInformacoes] = useState(false);
	const [mensagensErro, setMensagensErro] = useState([]);
	const [mensagensAviso, setMensagensAviso] = useState([]);
	const [mensagensSucesso, setMensagensSucesso] = useState([]);
	const [openListaErro, setOpenListaErro] = useState(false);
	const [openToastSucesso, setOpenToastSucesso] = useState(false);
	const [openToastErro, setOpenToastErro] = useState(false);
	const [openUsuario, setOpenUsuario] = useState(false);
	const [openHistoricoStatus, setOpenHistoricoStatus] = useState(false);
	const [openAlterarDatas, setOpenAlterarDatas] = useState(false);
	const [openHistoricoPedido, setOpenHistoricoPedido] = useState(false);
	const [openHistoricoFreteFiscal, setOpenHistoricoFreteFiscal] =
		useState(false);
	const [openProposta, setOpenProposta] = useState(false);
	const [semAutorizacao, setSemAutorizacao] = useState(false);
	const [openEmbarque, setOpenEmbarque] = useState(false);
	const [odenConfig, setOpenConfig] = useState(false);
	const [openLegenda, setOpenLegenda] = useState(false);
	const [openCTE, setOpenCTE] = useState(false);
	const [openStatus, setOpenStatus] = useState(false);
	const [openEmbalagem, setOpenEmbalagem] = useState(false);
	const [openMercadoria, setOpenMercadoria] = useState(false);
	const [openVeiculo, setOpenVeiculo] = useState(false);
	const [openMeioPagamento, setOpenMeioPagamento] = useState(false);
	const [openMotivoOnTime, setOpenMotivoOnTime] = useState(false);
	const [openMotivoCancelado, setOpenMotivoCancelado] = useState(false);
	const [openAlterarUnidadeEmbarque, setOpenAlterarUnidadeEmbarque] =
		useState(false);
	const [openInsightsViagem, setOpenInsightsViagem] = useState(false);

	const handleCloseCTE = (value) => {
		setOpenCTE(false);
	};

	const handleCloseStatus = () => {
		setOpenStatus(false);
	};

	const handleCloseEmbalagem = () => {
		setOpenEmbalagem(false);
	};

	const handleCloseMercadoria = () => {
		setOpenMercadoria(false);
	};

	const handleCloseVeiculo = () => {
		setVeiculo(null);
		setOpenVeiculo(false);
	};

	const handleCloseMeioPagamento = () => {
		setMeioPagamento1(null);
		setMeioPagamento2(null);
		setOpenMeioPagamento(false);
	};

	const handleCloseMotivoOnTime = () => {
		setOpenMotivoOnTime(false);
	};

	const handleCloseMotivoCancelado = () => {
		setOpenMotivoCancelado(false);
	};

	const handleOpenInsightsViagem = useCallback(() => {
		setOpenInsightsViagem(true);
	}, []);

	const handleCloseInsightsViagem = useCallback(() => {
		setOpenInsightsViagem(false);
	}, []);

	const buscarSMP = useCallback(async () => {
		await buscaSMP(embarqueIdSMP, profile?.token)
			.then((result) => {
				const lista = [];
				lista.push(result.data.smp);
				setStatusSMP(lista);
				setEmbarqueIdSMP(undefined);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	}, [embarqueIdSMP, profile?.token]);

	useEffect(() => {
		if (embarqueIdSMP) {
			buscarSMP();
		}
	}, [embarqueIdSMP, buscarSMP]);

	const [status, setStatus] = useState();
	const [embalagem, setEmbalagem] = useState();
	const [mercadoria, setMercadoria] = useState();
	const [veiculo, setVeiculo] = useState();
	const [meioPagamento1, setMeioPagamento1] = useState();
	const [meioPagamento2, setMeioPagamento2] = useState();
	const [motorista, setMotorista] = useState({
		id: 0,
		nome: "",
	});
	const [, setNomeMotivo] = useState();
	const [isEmbarque, setIsEmbarque] = useState(false);

	const [isEntrega, setIsEntrega] = useState(false);

	const [contextoCadastro, setContextoCadastro] = useState("");

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [openToastAviso, setOpenToastAviso] = useState(false);

	const [textoAviso, setTextoAviso] = useState("");

	const handleCloseToastAviso = (value) => {
		setOpenToastAviso(false);
	};

	const buscarViagensFiltro = useCallback(
		async (orderBy) => {
			setLoading(true);
			try {
				const filtro = Object.keys(filtroEmbarque).reduce((acc, key) => {
					const value = filtroEmbarque[key];

					if (
						key === FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueInicio ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueFim ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEntregaInicio ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEntregaFim
					) {
						acc[key] = value ? value.split("T")[0] : null;
					} else {
						acc[key] = value;
					}

					return acc;
				}, {});

				filtro[FiltroEmbarqueCompletoEnum.Contexto] = contextoEmbarque;

				const result = await buscarViagens({
					ordenarPor: orderBy ? orderBy : ordenarPor,
					token: profile?.token,
					filtro,
				});
				const dados = result?.data?.data || [];
				setDadosTabela(dados?.embarques);
				setSomatorioFreteFiscal(dados?.cards?.freteFiscalString);
				setSomatorioFreteMotorista(dados?.cards?.freteMotoristaString);
				setSomatorioIcms(dados?.cards?.icmsString);
				setSomatorioKm(dados?.cards?.kmString);
				setSomatorioExcedeuPisoAntt(
					dados?.cards?.somatorioExcedeuPisoAnttString
				);
				setSomatorioMargem(dados?.cards?.margem);
				const listaEmbarques = [];
				dados.embarques.forEach((embarque) => {
					if (embarque.cancelado === false && !filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
					if (embarque.cancelado === true && filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
				});
				setNumeroEmbarques(listaEmbarques.length);
				buscouEmbarques.current = true;
			} catch (error) {
				console.error("Erro ao buscar viagens com filtro:", error);
				setTextoErro("Erro ao buscar viagens. Tente novamente.");
				setOpenToastErro(true);
			}
			setLoading(false);
		},
		[filtroEmbarque, contextoEmbarque, profile?.token, ordenarPor]
	);

	const handleSearch = useCallback(
		(ordenarPor) => {
			setOrdenarPor(ordenarPor);
			buscarViagensFiltro(ordenarPor);
		},
		[buscarViagensFiltro, setOrdenarPor]
	);

	useEffect(() => {
		if (profile?.token) {
			if (dadosRequestControllerRedux === "Cadastro False") {
				setDadosRequestControllerRedux("");
			}
			if (dadosRequestControllerRedux.includes("Cadastro False Sucesso")) {
				handleSearch();

				setDadosRequestControllerRedux("");
				setTextoSucesso("Cadastrado Com Sucesso");
				setOpenToastSucesso(true);
				if (
					dadosRequestControllerRedux.split("Cadastro False Sucesso")[1] !== ""
				) {
					setTextoAviso(
						dadosRequestControllerRedux.split("Cadastro False Sucesso")[1]
					);
					setOpenToastAviso(true);
				}
			}
			if (dadosRequestControllerRedux === "Close Motivo") {
				fetchMotivos();
				setDadosRequestControllerRedux("");
			}
			if (dadosRequestControllerRedux === "Close Status") {
				fetchStatus();
				setDadosRequestControllerRedux("");
			}
			if (dadosRequestControllerRedux === "Close Mercadoria") {
				fetchMercadorias();
				setDadosRequestControllerRedux("");
			}
			if (dadosRequestControllerRedux === "Close Embalagem") {
				fetchEmbalagens();
				setDadosRequestControllerRedux("");
			}
			if (dadosRequestControllerRedux === "Close Veiculo") {
				fetchVeiculos(profile?.token);
				setDadosRequestControllerRedux("");
			}
		}
	}, [
		dadosRequestControllerRedux,
		profile?.token,
		contextoEmbarque,
		fetchMotivos,
		fetchStatus,
		fetchMercadorias,
		fetchEmbalagens,
		fetchVeiculos,
		handleSearch,
		setDadosRequestControllerRedux,
	]);

	const [dadosTabela, setDadosTabela] = useState([]);
	const [somatorioFreteFiscal, setSomatorioFreteFiscal] = useState("0,00");
	const [somatorioFreteMotorista, setSomatorioFreteMotorista] =
		useState("0,00");
	const [somatorioIcms, setSomatorioIcms] = useState("0,00");
	const [somatorioKm, setSomatorioKm] = useState("0,00");
	const [somatorioExcedeuPisoAntt, setSomatorioExcedeuPisoAntt] =
		useState("0,00");
	const [somatorioMargem, setSomatorioMargem] = useState("0,00");
	const [cardSomatorio, setCardSomatorio] = useState(false);
	const [numeroEmbarque, setNumeroEmbarques] = useState(0);
	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState([]);
	const [open, setOpen] = useState(false);
	const [textoSucesso, setTextoSucesso] = useState("");
	const [textoErro, setTextoErro] = useState("");
	const [valoresHistorico, setValoresHistorico] = useState([]);
	const [valoresHistoricoStatus, setValoresHistoricoStatus] = useState([]);
	const [valoresHistoricoPedido, setValoresHistoricoPedido] = useState([]);
	const [valoresHistoricoFreteFiscal, setValoresHistoricoFreteFiscal] =
		useState([]);
	const [openHistoricoEdicao, setOpenHistoricoEdicao] = useState(false);
	const [openCadastroPedido, setOpenCadastroPedido] = useState(false);
	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const handleClickEdit = useCallback(() => {
		if (!!contextoEmbarque && !!tabelaRedux.colunaSelecionada) {
			navigate(
				`/viagens/${contextoEmbarque}/cadastro/${tabelaRedux.colunaSelecionada}`
			);
		} else {
			showToast("Selecione uma viagem para editar.", "error");
		}
	}, [tabelaRedux, contextoEmbarque, navigate, showToast]);

	const handleClickEditOrigem = useCallback(() => {
		if (!!contextoEmbarque && !!tabelaRedux.colunaSelecionada) {
			const context = tabelaRedux.row?.contexto
				? tabelaRedux.row?.contexto
				: contextoEmbarque;
			window.open(
				`/viagens/${context}/cadastro/${tabelaRedux.colunaSelecionada}/origem`,
				"_blank"
			);
		} else {
			showToast("Selecione uma viagem para editar.", "error");
		}
		toggleDropdown();
	}, [
		tabelaRedux.row?.contexto,
		tabelaRedux.colunaSelecionada,
		contextoEmbarque,
		showToast,
		toggleDropdown,
	]);

	const acoesData = [
		...(contextoEmbarque === "frota"
			? [
				{
					titulo: "Editar tela origem",
					onClick: handleClickEditOrigem,
				},
			]
			: []),
		{
			titulo: "Editar datas",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalEditarDatas();
			},
		},
		{
			titulo: "Alterar Unid Embarque",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalAlterarUnidadeEmbarque();
			},
		},
		{
			titulo: "Buscar Histórico Status",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoStatus();
			},
		},
		{
			titulo: "Buscar Histórico Pedido",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoPedido();
			},
		},
		{
			titulo: "Buscar Histórico Frete Fiscal",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoFreteFiscal();
			},
		},
		{
			titulo: "Buscar Status SMP",
			onClick: () => {
				setEmbarqueIdSMP(tabelaRedux.colunaSelecionada);
			},
		},
		{
			titulo: "Inserir SMP",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenConfirmar(true);
			},
		},
		{
			titulo: "Definir Meios de Pagamento",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMeioPagamento(true);
			},
		},
		{
			titulo: "Informar Comprovante",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				definirComprovante();
			},
		},
		{
			titulo: "Informar Checkin Concluído",
			onClick: () => {
				definirCheck();
			},
		},
		{
			titulo: "Lançar Status",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenStatus(true);
			},
		},
		{
			titulo: "Lançar Mercadoria",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMercadoria(true);
			},
		},
		{
			titulo: "Lançar Embalagem",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenEmbalagem(true);
			},
		},
		{
			titulo: "Lançar Veículo",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenVeiculo(true);
			},
		},
		{
			titulo: "Lançar CTE",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenCTE(true);
			},
		},
		{
			titulo: "Motivo Viagem",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				if (tabelaRedux?.row?.necessitaMotivoEmbarque === true) {
					setIsEmbarque(true);
					setIsEntrega(false);
					setOpenMotivoOnTime(true);
				} else {
					setTextoErro("Carga não necessita de motivo");
					setOpenToastErro(true);
				}
			},
		},
		{
			titulo: "Motivo Entrega",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				if (tabelaRedux?.row?.necessitaMotivoEntrega === true) {
					setIsEmbarque(false);
					setIsEntrega(true);
					setOpenMotivoOnTime(true);
				} else {
					setTextoErro("Carga não necessita de motivo");
					setOpenToastErro(true);
				}
			},
		},
		{
			titulo: "Cancelar Carga",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMotivoCancelado(true);
			},
		},
	];

	useEffect(() => {
		const storedCardSomatorio = localStorage.getItem("cardSomatorio");
		if (!storedCardSomatorio) {
			setCardSomatorio(false);
		} else {
			setCardSomatorio(storedCardSomatorio === "true");
		}
	}, []);

	const onClickOpenSomatorio = () => {
		const newCardSomatorio = !cardSomatorio;
		localStorage.setItem("cardSomatorio", newCardSomatorio);
		setCardSomatorio(newCardSomatorio);
	};

	const buscarOrdenacao = (novaOrdem) => {
		handleSearch(novaOrdem);
	};

	const buscarEmbarquesInicial = useCallback(async () => {
		try {
			if (profile?.token && contextoEmbarque) {
				setLoading(true);

				const filtroInicial = {
					...emptyFiltroEmbarque,
					[FiltroEmbarqueCompletoEnum.Contexto]: contextoEmbarque,
				};

				const result = await buscarViagens({
					ordenarPor: "previsaoEmbarque",
					token: profile?.token,
					filtro: filtroInicial,
				});

				const dados = result?.data?.data || [];
				setDadosTabela(dados?.embarques);
				setSomatorioFreteFiscal(dados?.cards?.freteFiscalString);
				setSomatorioFreteMotorista(dados?.cards?.freteMotoristaString);
				setSomatorioIcms(dados?.cards?.icmsString);
				setSomatorioKm(dados?.cards?.kmString);
				setSomatorioExcedeuPisoAntt(
					dados?.cards?.somatorioExcedeuPisoAnttString
				);
				setSomatorioMargem(dados?.cards?.margem);
				const listaEmbarques = [];
				dados.embarques.forEach((embarque) => {
					if (embarque.cancelado === false && !filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
					if (embarque.cancelado === true && filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
				});
				setNumeroEmbarques(listaEmbarques.length);
				buscouEmbarques.current = true;
			}
		} catch (error) {
			console.error("Erro ao buscar viagens com filtro:", error);
			setTextoErro("Erro ao buscar viagens. Tente novamente.");
			setOpenToastErro(true);
		}
		setLoading(false);
	}, [profile?.token, contextoEmbarque, filtroEmbarque.cancelado]);

	const limparMultiplosFiltros = useCallback(() => {
		clearFiltros();
		buscarEmbarquesInicial();
	}, [clearFiltros, buscarEmbarquesInicial]);

	const buscarViagensFiltroClipboard = useCallback(
		async (filtros) => {
			try {
				setLoading(true);

				const filtro = Object.keys(filtros).reduce((acc, key) => {
					const value = filtros[key];

					if (
						key === FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueInicio ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueFim ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEntregaInicio ||
						key === FiltroEmbarqueCompletoEnum.PrevisaoEntregaFim
					) {
						acc[key] = value ? value.split("T")[0] : null;
					} else {
						acc[key] = value;
					}

					return acc;
				}, {});

				filtro[FiltroEmbarqueCompletoEnum.Contexto] = contextoEmbarque;

				const result = await buscarViagens({
					ordenarPor: ordenarPor,
					token: profile?.token,
					filtro,
				});
				const dados = result?.data?.data || [];
				setDadosTabela(dados?.embarques);
				setSomatorioFreteFiscal(dados?.cards?.freteFiscalString);
				setSomatorioFreteMotorista(dados?.cards?.freteMotoristaString);
				setSomatorioIcms(dados?.cards?.icmsString);
				setSomatorioKm(dados?.cards?.kmString);
				setSomatorioExcedeuPisoAntt(
					dados?.cards?.somatorioExcedeuPisoAnttString
				);
				setSomatorioMargem(dados?.cards?.margem);
				const listaEmbarques = [];
				dados.embarques.forEach((embarque) => {
					if (embarque.cancelado === false && !filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
					if (embarque.cancelado === true && filtroEmbarque.cancelado) {
						listaEmbarques.push(embarque);
					}
				});
				setNumeroEmbarques(listaEmbarques.length);
			} catch (error) {
				console.error("Erro ao buscar viagens com filtro:", error);
				setTextoErro("Erro ao buscar viagens. Tente novamente.");
				setOpenToastErro(true);
			}
			setLoading(false);
		},
		[filtroEmbarque, contextoEmbarque, profile?.token, ordenarPor]
	);

	const buscarSearch = useCallback(
		async (ordenarPor) => {
			if (!profile?.token) return;
			setLoading(true);
			let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
			if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
				for (let filtro of multiplosFiltrosRedux) {
					pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
				}
			}

			let embarqueInicio = formatDate(valuesPesquisa.dataInicio);
			let embarqueFinal = formatDate(valuesPesquisa.dataFim);

			if (!embarqueInicio) {
				embarqueInicio = primeiroDiaDosMesFormatado;
			}

			if (!embarqueFinal) {
				embarqueFinal = ultimoDiaDosMesFormatado;
			}

			await getEmbarqueSearch({
				token: profile?.token,
				pesquisa: pesquisaFormatada,
				contexto: contextoEmbarque,
				dataInicio: embarqueInicio,
				dataFim: embarqueFinal,
				ordenarPor,
				cancelado: filtroEmbarque.cancelado ? true : false,
			})
				.then((result) => {
					setDadosTabela(result.data.embarques);
					setSomatorioFreteFiscal(result.data?.cards?.freteFiscalString);
					setSomatorioFreteMotorista(result.data?.cards?.freteMotoristaString);
					setSomatorioIcms(result.data?.cards?.icmsString);
					setSomatorioKm(result.data?.cards?.kmString);
					setSomatorioExcedeuPisoAntt(
						result.data?.cards?.somatorioExcedeuPisoAnttString
					);
					setSomatorioMargem(result.data?.cards?.margem);
					const listaEmbarques = [];
					result.data.embarques.forEach((embarque) => {
						if (embarque.cancelado === false && !filtroEmbarque.cancelado) {
							listaEmbarques.push(embarque);
						}
						if (embarque.cancelado === true && filtroEmbarque.cancelado) {
							listaEmbarques.push(embarque);
						}
					});
					setNumeroEmbarques(listaEmbarques.length);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				});

			setLoading(false);
		},
		[
			valuesPesquisa,
			multiplosFiltrosRedux,
			contextoEmbarque,
			filtroEmbarque.cancelado,
			profile?.token,
		]
	);

	const handleOnSuccessEditarDatas = useCallback(() => {
		if (isFiltroModified()) {
			buscarViagensFiltro();
		} else {
			buscarEmbarquesInicial();
		}
	}, [isFiltroModified, buscarViagensFiltro, buscarEmbarquesInicial]);

	const handleCloseCadastroPedido = (value) => {
		setLoading(true);
		buscarDependenciasSemLoading();
		setOpenCadastroPedido(false);
	};

	const [openCadastroUnidadeEmbarque, setOpenCadastroUnidadeEmbarque] =
		useState(false);

	const handleCloseCadastroUnidadeEmbarque = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroUnidadeEmbarque(false);
	};

	const handleCloseCadastroFilial = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroFilial(false);
	};

	const handleCloseCadastroEmpresa = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroEmpresa(false);
	};

	const handleCloseCadastroVeiculo = (value) => {
		setLoading(true);
		buscarDependenciasSemLoading();
		setOpenCadastroVeiculo(false);
	};

	const handleCloseCadastroMercadoria = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroMercadoria(false);
	};

	const handleCloseCadastroEmbalagem = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroEmbalagem(false);
	};

	const handleCloseCadastroStatus = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroStatus(false);
	};

	const handleCloseCadastroMotivo = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroMotivo(false);
	};

	const [openCadastroMeioPagamento, setOpenCadastroMeioPagamento] =
		useState(false);

	const handleCloseCadastroMeioPagamento = (value) => {
		buscarDependenciasSemLoading();
		setOpenCadastroMeioPagamento(false);
	};

	const handleCloseConfirmar = (value) => {
		setOpenConfirmar(false);
	};

	const handleCloseModalInformacoes = (value) => {
		setOpenModalInformacoes(false);
	};
	const [statusSMP, setStatusSMP] = useState(null);

	const handleCloseListaErro = (value) => {
		setOpenListaErro(false);
		handleSearch();
	};

	const handleCloseHistoricoEdicao = (value) => {
		setOpenHistoricoEdicao(false);
	};
	const handleClose = (value) => {
		setOpen(false);
	};

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const handleCloseHistoricoStatus = (value) => {
		setOpenHistoricoStatus(false);
	};

	const abrirModalHistoricoStatus = () => {
		buscarStatusEmbarquePorId();
	};

	const abrirModalEditarDatas = useCallback(() => {
		setOpenAlterarDatas(true);
	}, []);

	const abrirModalAlterarUnidadeEmbarque = useCallback(() => {
		setOpenAlterarUnidadeEmbarque(true);
	}, []);

	const handleCloseAlterarUnidadeEmbarque = useCallback(() => {
		setOpenAlterarUnidadeEmbarque(false);
	}, []);

	const handleCloseHistoricoPedido = (value) => {
		setOpenHistoricoPedido(false);
	};

	const abrirModalHistoricoPedido = () => {
		buscarPedidoEmbarquePorId();
	};

	const handleCloseHistoricoFreteFiscal = (value) => {
		setOpenHistoricoFreteFiscal(false);
	};

	const abrirModalHistoricoFreteFiscal = () => {
		buscarFreteFiscalEmbarquePorId();
	};

	const handleCloseProposta = (value) => {
		setOpenProposta(false);
	};

	const buscarDependenciasSemLoading = useCallback(async () => {
		if (!profile?.token) return;
		const date = new Date();
		var ddFinal = String(date?.getDate()).padStart(2, "0");
		var mmFinal = String(date?.getMonth() + 1).padStart(2, "0");
		var yyyyFinal = date?.getFullYear();
		var dateFinalFormated = yyyyFinal + "-" + mmFinal + "-" + ddFinal;

		await getEmbarqueGeral(profile?.token, contextoEmbarque, dateFinalFormated)
			.then((result) => {
				setDadosTabela(result.data.embarques);
				setSomatorioFreteFiscal(result.data?.cards?.freteFiscalString);
				setSomatorioFreteMotorista(result.data?.cards?.freteMotoristaString);
				setSomatorioIcms(result.data?.cards?.icmsString);
				setSomatorioKm(result.data?.cards?.kmString);
				setSomatorioExcedeuPisoAntt(
					result.data?.cards?.somatorioExcedeuPisoAnttString
				);
				setSomatorioMargem(result.data?.cards?.margem);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [contextoEmbarque, profile?.token, setTabelaRedux]);

	const buscarHistoricoEmbarque = async (codigo) => {
		if (codigo === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoEmbarque(codigo, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValoresHistorico(result.data);
						setOpenHistoricoEdicao(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarStatusEmbarquePorId = async (flag) => {
		await getEmbarquePorId({
			id: tabelaRedux.colunaSelecionada,
			token: profile?.token,
		})
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoStatus(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const buscarPedidoEmbarquePorId = async (flag) => {
		await getEmbarquePorId({
			id: tabelaRedux.colunaSelecionada,
			token: profile?.token,
		})
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoPedido(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const buscarFreteFiscalEmbarquePorId = async (flag) => {
		await getEmbarquePorId({
			id: tabelaRedux.colunaSelecionada,
			token: profile?.token,
		})
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoFreteFiscal(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const buscarHistoricoStatus = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoStatus(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValoresHistoricoStatus(result.data);
						setOpenHistoricoStatus(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarHistoricoPedido = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoPedido(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValoresHistoricoPedido(result.data);
						setOpenHistoricoPedido(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarHistoricoFreteFiscal = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoFreteFiscal(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValoresHistoricoFreteFiscal(result.data);
						setOpenHistoricoFreteFiscal(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarEmbarquePorId = async (flag) => {
		await getEmbarquePorId({
			id: tabelaRedux.colunaSelecionada,
			token: profile?.token,
		})
			.then((result) => {
				if (result.status === 200) {
					if (flag) {
						buscarHistoricoEmbarque(result.data.embarqueHistoricoId);
					}
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const deletarEmbarquePorId = async () => {
		setLoading(true);

		await deleteEmbarquePorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setValues((current) => ({
						...current,
						contexto: contextoEmbarque,
					}));
					setTabelaRedux({});
					setOpenToastSucesso(true);
					buscarSearch();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});

		setLoading(false);
	};

	useEffect(() => {
		if (profile?.token && !hasLoaded.current) {
			hasLoaded.current = true;
			setValuesPesquisa([]);
			setTabelaRedux({});
			setValues({});
			setDadosRequestControllerRedux("Cadastro False");
			dadosFilial?.map((item) => {
				if (contextoEmbarque === item.contexto) {
					setContextoCadastro(item.nomeFilial);
				}
				return null;
			});
			setValues((current) => ({ ...current, contexto: contextoEmbarque }));

			if (isFiltroModified()) {
				buscarViagensFiltro();
			} else {
				buscarEmbarquesInicial();
			}
			if (profile?.usuario.usuario) {
				setValues((current) => ({
					...current,
					usuario: profile?.usuario.usuario,
				}));
			}
		}
	}, [
		contextoEmbarque,
		profile?.token,
		buscarEmbarquesInicial,
		buscarViagensFiltro,
		isFiltroModified,
		setDadosRequestControllerRedux,
		setTabelaRedux,
		setValuesPesquisa,
		profile?.usuario.usuario,
		dadosFilial,
	]);

	const handleClearToasts = useCallback(() => {
		setOpenToastSucesso(false);
		setOpenToastErro(false);
	}, []);

	const handleCloseEmbarque = (value) => {
		setOpenEmbarque(false);
	};

	const title = useMemo(() => {
		return `Viagens - ${contextoCadastro}`;
	}, [contextoCadastro]);

	const validaContextoERegras = useCallback(async () => {
		if (!profile) return;
		setLoading(true);
		try {
			if (!contextoEmbarque) {
				setOpenEmbarque(true);
				setSemAutorizacao(true);
			}

			let regraPagina = dadosFilial.find(
				(item) => item.contexto === contextoEmbarque
			)?.nomeRegra;

			setSemAutorizacao(!hasRegra(regraPagina));
		} catch (error) {
			const errorMessage =
				typeof error.response?.data === "string"
					? error.response.data
					: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.";
			setTextoErro(errorMessage);
			setOpenToastErro(true);
		}
		setLoading(false);
	}, [profile, contextoEmbarque, dadosFilial, hasRegra]);

	useEffect(() => {
		if (values.dataEmbarque === "2000-01-01") {
			values.dataEmbarque = "";
		}
		if (values.dataEntrega === "2000-01-01") {
			values.dataEntrega = "";
		}
		if (values.previsaoEmbarque === "2000-01-01") {
			values.previsaoEmbarque = "";
		}
		if (values.previsaoEntrega === "2000-01-01") {
			values.previsaoEntrega = "";
		}
		if (
			values.dataHoraChegadaEmbarque === "2000-01-01T00:00:00" ||
			values.dataHoraChegadaEmbarque === "2000-01-01T00:00"
		) {
			values.dataHoraChegadaEmbarque = "";
		}
		if (
			values.dataHoraChegadaEntrega === "2000-01-01T00:00:00" ||
			values.dataHoraChegadaEntrega === "2000-01-01T00:00"
		) {
			values.dataHoraChegadaEntrega = "";
		}
		if (
			values.dataHoraEntregue === "2000-01-01T00:00:00" ||
			values.dataHoraEntregue === "2000-01-01T00:00"
		) {
			values.dataHoraEntregue = "";
		}
		if (
			values.dataHoraEmbarcado === "2000-01-01T00:00:00" ||
			values.dataHoraEmbarcado === "2000-01-01T00:00"
		) {
			values.dataHoraEmbarcado = "";
		}
		validaContextoERegras();
	}, [contextoEmbarque, validaContextoERegras, values]);

	const inserirSMP = async () => {
		await insereSMP(embarqueId, profile?.token)
			.then((result) => {
				setMensagensAviso(result.data.result.mensagensAviso);
				setMensagensErro(result.data.result.mensagensErro);
				setMensagensSucesso(result.data.result.mensagensSucesso);
				setOpenListaErro(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	useEffect(() => {
		if (statusSMP) {
			setOpenModalInformacoes(true);
		}
	}, [statusSMP]);

	const onSuccessDefinirCte = useCallback(() => {
		setTextoSucesso("CTE Definido com Sucesso!");
		setOpenToastSucesso(true);
		handleSearch();
	}, [handleSearch]);

	const onErrorDefinirCte = useCallback((error) => {
		if (typeof error?.response?.data === "string") {
			setTextoErro(error.response.data);
		} else if (typeof error === "string") {
			setTextoErro(error);
		} else {
			setTextoErro(
				"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
			);
		}
		setOpenToastErro(true);
	}, []);

	const statusEmbarqueCancelado = useMemo(() => {
		return {
			statusId: status,
			embarqueId: embarqueId,
		};
	}, [status, embarqueId]);

	const definirStatus = useCallback(async () => {
		await lancarStatus(statusEmbarqueCancelado, profile?.token)
			.then(() => {
				handleCloseStatus();
				setTextoSucesso("Status Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	}, [statusEmbarqueCancelado, profile?.token, handleSearch]);

	const embarqueCancelado = useMemo(() => {
		return {
			embarqueId: embarqueId,
			meioPagamentoId: meioPagamento1,
			meioPagamento2Id: meioPagamento2,
		};
	}, [embarqueId, meioPagamento1, meioPagamento2]);

	const definirMeioPagameto = async () => {
		await definirMeiosPagamentos(embarqueCancelado, profile?.token)
			.then(() => {
				handleCloseMeioPagamento();
				setMeioPagamento1(null);
				setMeioPagamento2(null);
				setTextoSucesso("Meios de Pagamento Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const definirVeiculo = async () => {
		const embarqueCancelado = {
			embarqueId: embarqueId,
			veiculoId: veiculo,
			motoristaId: motorista.id,
		};
		await lancarVeiculo(embarqueCancelado, profile?.token)
			.then(() => {
				handleCloseVeiculo();
				setMotorista({ id: 0, nome: "" });
				setVeiculo(null);
				setTextoSucesso("Veiculo Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const definirMercadoria = async () => {
		const embarqueCancelado = {
			mercadoriaId: mercadoria,
			embarqueId: embarqueId,
		};
		await lancarMercadoria(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseMercadoria();
				setTextoSucesso("Mercadoria Definida com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const definirEmbalagem = async () => {
		const embarqueCancelado = {
			embalagemId: embalagem,
			embarqueId: embarqueId,
		};
		await lancarEmbalagem(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseEmbalagem();
				setTextoSucesso("Embalagem Definida com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const definirComprovante = async () => {
		await comprovanteEntregue(embarqueId, profile?.token)
			.then((result) => {
				setTextoSucesso("Comprovante Informado com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const definirCheck = async () => {
		await lancarCheckin(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				setTextoSucesso("Checkin Concluído com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const cancelarCarga = async () => {
		const embarqueCancelado = {
			motivoId: motivoId2,
			embarqueId: embarqueId,
		};
		if (!motivoId2) {
			showToast("Selecione um motivo para cancelar a carga.", "error");
			return;
		}
		await cancelarEmbarque(embarqueCancelado, profile?.token)
			.then((result) => {
				setOpenMotivoCancelado(false);
				setNomeMotivo(null);
				setMotivoId(null);
				setTextoSucesso("Carga Cancelada com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const vincularMotivoOnTime = async () => {
		let bool = false;
		if (isEmbarque === true) {
			bool = true;
		}
		if (isEntrega === true) {
			bool = false;
		}
		await vincularMotivoPorId(profile?.token, embarqueId, motivoId, bool)
			.then((result) => {
				if (result.status === 200) {
					handleCloseMotivoOnTime();
					fetchMotivos();
					setNomeMotivo(null);
					setMotivoId(null);
					setTextoSucesso("Cadastrado com Sucesso!");
					setOpenToastSucesso(true);
					setEmbarqueId(null);
					handleSearch();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	};

	const handleCloseConfig = (value) => {
		if (dadosRequestControllerRedux === "Sucesso") {
			setTextoSucesso("Alterado Com Sucesso");
			setOpenToastSucesso(true);
			setOpenConfig(false);
			handleSearch();
		}
		setOpenConfig(false);
		handleSearch();
	};

	const handleCloseLegenda = (value) => {
		setOpenLegenda(false);
	};

	const handleClickCadastrar = useCallback(() => {
		navigate(`/viagens/${contextoEmbarque}/cadastro`);
	}, [contextoEmbarque, navigate]);

	const listaFiltradaObjetos = useMemo(() => {
		return dadosTabela.map((obj) => {
			const novoObjeto = Object.keys(obj)
				.filter((key) => !chavesRemover.includes(key))
				.reduce((novoObjeto, key) => {
					novoObjeto[key] = obj[key];
					return novoObjeto;
				}, {});
			return novoObjeto;
		});
	}, [dadosTabela]);

	const listaFormatada = listaFiltradaObjetos.map((obj) => {
		const novoObj = {};

		if (obj.pedidoEmbarque?.rota?.cidadeOrigemRota) {
			novoObj.cidadeOrigem = obj.pedidoEmbarque.rota.cidadeOrigemRota.cidade;
			novoObj.estadoOrigem = obj.pedidoEmbarque.rota.cidadeOrigemRota.estado;
		}

		if (obj.pedidoEmbarque?.rota?.cidadeDestinoRota) {
			novoObj.cidadeDestino = obj.pedidoEmbarque.rota.cidadeDestinoRota.cidade;
			novoObj.estadoDestino = obj.pedidoEmbarque.rota.cidadeDestinoRota.estado;
		}
		Object.keys(obj).forEach((key) => {
			const valor = obj[key];

			if (chavesFormatar.includes(key) && valor) {
				const dataHora = new Date(valor);
				if (dataHora.toISOString() === "2000-01-01T02:00:00.000Z") {
					novoObj[key] = "";
				} else {
					const dataFormatada = `${dataHora.toLocaleDateString(
						"pt-BR"
					)} ${dataHora.toLocaleTimeString("pt-BR")}`;
					novoObj[key] = dataFormatada;
				}
			} else if (["checkInFeito", "comprovante", "cancelado"].includes(key)) {
				novoObj[key] = valor === true ? "Sim" : valor === false ? "Não" : valor;
			} else if (["motorista"].includes(key)) {
				novoObj[key] = obj?.veiculoMotorista?.nome;
			} else {
				novoObj[key] = valor;
			}
		});
		return novoObj;
	});

	const isLoading = useMemo(() => {
		return (
			loading ||
			!profile?.token ||
			(!dadosTabela?.length && !buscouEmbarques.current) ||
			isContextLoading ||
			!contextoEmbarque
		);
	}, [
		loading,
		dadosTabela,
		profile?.token,
		isContextLoading,
		contextoEmbarque,
	]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title}>
			{contextoEmbarque !== "todos" ? (
				<MotionContainer key={contextoEmbarque}>
					<div className="content-container">
						<FiltroViagens
							buscarViagens={buscarViagensFiltro}
							buscarViagensClipboard={buscarViagensFiltroClipboard}
							onClearFiltros={limparMultiplosFiltros}
							clearToasts={handleClearToasts}
							listaFormatada={listaFormatada}
							disabled={isLoading}
						/>
						{cardSomatorio && contextoEmbarque !== "templateEmbarque" && (
							<>
								<CardSomatorio
									numeroEmbarque={numeroEmbarque}
									somatorioIcms={somatorioIcms}
									somatorioKm={somatorioKm}
									somatorioExcedeuPisoAntt={somatorioExcedeuPisoAntt}
									somatorioMargem={somatorioMargem}
									somatorioFreteFiscal={somatorioFreteFiscal}
									somatorioFreteMotorista={somatorioFreteMotorista}
								/>
								<Separator size="xl" />
							</>
						)}
						<TabelaEmbarqueVirtualizada
							dados={dadosTabela}
							buscarOrdenacao={buscarOrdenacao}
							isLoading={isLoading}
						/>
					</div>
					<div className="footer-space-between">
						<div>
							<CustomButtonV2
								classCss="custom-button-cadastrar"
								classText="button-texto-cadastrar"
								icone="iconeSave"
								titulo="Cadastrar"
								cor="#0946B8"
								valor={values}
								onClick={handleClickCadastrar}
							/>
							<CustomButtonV2
								classCss="custom-button-editar"
								classText="button-texto-editar"
								titulo="Editar"
								icone="iconeEdit"
								cor="#CDCDCD"
								valor={values}
								onClick={handleClickEdit}
							/>
							<CustomButtonV2
								classCss="custom-button-deletar"
								classText="button-texto-cadastrar"
								titulo="Deletar"
								icone="iconeDelete"
								cor="#DC2D2D"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										setOpen(true);
										setTextoSucesso("Deletado Com Sucesso");
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
						</div>
						<div className="flex-row">
							{contextoEmbarque !== "templateEmbarque" && (
								<>
									<CustomButtonV2
										classCss="custom-button-user"
										classText="button-texto-faturamento"
										titulo={"Exibir Somatório"}
										cor="#FFFFFF"
										onClick={onClickOpenSomatorio}
									/>
									<div className="hover-emb" ref={refDropdown}>
										<AnimatePresence mode="wait">
											{isOpenDropdown && (
												<motion.div
													initial={{ opacity: 0, y: 20 }}
													animate={{ opacity: 1, y: 0 }}
													exit={{ opacity: 0, y: 20 }}
													transition={{ duration: 0.3 }}
													className="acoes-dropdown"
												>
													{acoesData.map((acao) => (
														<motion.p
															key={acao.titulo}
															onClick={acao.onClick}
															initial={{ scale: 1, backgroundColor: "#fff" }}
															whileHover={{
																scale: 1.03,
																backgroundColor: "#f0f0f0",
															}}
															whileTap={{ scale: 0.95 }}
															transition={{ duration: 0.2 }}
														>
															{acao.titulo}
														</motion.p>
													))}
												</motion.div>
											)}
										</AnimatePresence>
										<CustomButtonV2
											classCss="custom-button-user"
											classText="button-texto-user"
											titulo="Ações"
											cor="#FFFFFF"
											valor={values}
											disabled={buscandoEmbarqueEDependencias}
											onClick={() => {
												if (tabelaRedux.colunaSelecionada) {
													toggleDropdown();
												} else {
													showToast("Selecione uma coluna", "error");
												}
											}}
										/>
									</div>
								</>
							)}
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-user"
								titulo="Obter Usuário"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.usuarioAlteracao) {
										setOpenUsuario(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							{contextoEmbarque !== "templateEmbarque" && (
								<CustomButtonV2
									classCss="custom-button-historico"
									classText="button-texto-user"
									titulo="Histórico"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											buscarEmbarquePorId(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							)}
						</div>
					</div>
				</MotionContainer>
			) : (
				<MotionContainer key="TodosEmbarques">
					<div className="content-container">
						<FiltroViagens
							buscarViagens={buscarViagensFiltro}
							buscarViagensClipboard={buscarViagensFiltroClipboard}
							onClearFiltros={limparMultiplosFiltros}
							clearToasts={handleClearToasts}
							listaFormatada={listaFormatada}
							disabled={isLoading}
						/>
						{cardSomatorio && contextoEmbarque !== "templateEmbarque" && (
							<>
								<CardSomatorio
									numeroEmbarque={numeroEmbarque}
									somatorioIcms={somatorioIcms}
									somatorioKm={somatorioKm}
									somatorioExcedeuPisoAntt={somatorioExcedeuPisoAntt}
									somatorioMargem={somatorioMargem}
									somatorioFreteFiscal={somatorioFreteFiscal}
									somatorioFreteMotorista={somatorioFreteMotorista}
								/>
								<Separator size="xl" />
							</>
						)}
						<TabelaEmbarqueVirtualizada
							dados={dadosTabela}
							buscarOrdenacao={buscarOrdenacao}
							isLoading={isLoading}
						/>
					</div>
					<div className="footer-space-between">
						<div>
							{contextoEmbarque !== "templateEmbarque" && (
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Exibir Somatório"
									cor="#FFFFFF"
									onClick={onClickOpenSomatorio}
								/>
							)}
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-user"
								titulo="Obter Usuário"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.usuarioAlteracao) {
										setOpenUsuario(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-historico"
								classText="button-texto-user"
								titulo="Histórico"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										buscarEmbarquePorId(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
						</div>
						<div>
							<IAHelpButton
								onClick={handleOpenInsightsViagem}
							>
								<span>Insights Viagens</span>
							</IAHelpButton>
						</div>
					</div>
				</MotionContainer>
			)}
			<ModaisEmbarque
				openCadastroPedido={openCadastroPedido}
				handleCloseCadastroPedido={handleCloseCadastroPedido}
				openCadastroUnidadeEmbarque={openCadastroUnidadeEmbarque}
				handleCloseCadastroUnidadeEmbarque={handleCloseCadastroUnidadeEmbarque}
				openCadastroFilial={openCadastroFilial}
				handleCloseCadastroFilial={handleCloseCadastroFilial}
				openCadastroEmpresa={openCadastroEmpresa}
				handleCloseCadastroEmpresa={handleCloseCadastroEmpresa}
				openCadastroVeiculo={openCadastroVeiculo}
				handleCloseCadastroVeiculo={handleCloseCadastroVeiculo}
				openCadastroMercadoria={openCadastroMercadoria}
				handleCloseCadastroMercadoria={handleCloseCadastroMercadoria}
				openCadastroEmbalagem={openCadastroEmbalagem}
				handleCloseCadastroEmbalagem={handleCloseCadastroEmbalagem}
				openCadastroStatus={openCadastroStatus}
				handleCloseCadastroStatus={handleCloseCadastroStatus}
				openCadastroMotivo={openCadastroMotivo}
				handleCloseCadastroMotivo={handleCloseCadastroMotivo}
				openCadastroMeioPagamento={openCadastroMeioPagamento}
				handleCloseCadastroMeioPagamento={handleCloseCadastroMeioPagamento}
				open={open}
				handleClose={handleClose}
				deletarEmbarquePorId={deletarEmbarquePorId}
				openConfirmar={openConfirmar}
				handleCloseConfirmar={handleCloseConfirmar}
				inserirSMP={inserirSMP}
				openModalInformacoes={openModalInformacoes}
				handleCloseModalInformacoes={handleCloseModalInformacoes}
				statusSMP={statusSMP}
				openListaErro={openListaErro}
				handleCloseListaErro={handleCloseListaErro}
				mensagensAviso={mensagensAviso}
				mensagensErro={mensagensErro}
				mensagensSucesso={mensagensSucesso}
				openUsuario={openUsuario}
				handleCloseUsuario={handleCloseUsuario}
				openLegenda={openLegenda}
				handleCloseLegenda={handleCloseLegenda}
				openHistoricoStatus={openHistoricoStatus}
				handleCloseHistoricoStatus={handleCloseHistoricoStatus}
				valoresHistoricoStatus={valoresHistoricoStatus}
				colunasStatusEmbarque={colunasStatusEmbarque}
				openHistoricoPedido={openHistoricoPedido}
				handleCloseHistoricoPedido={handleCloseHistoricoPedido}
				valoresHistoricoPedido={valoresHistoricoPedido}
				colunasPedidoEmbarque={colunasPedidoEmbarque}
				openHistoricoFreteFiscal={openHistoricoFreteFiscal}
				handleCloseHistoricoFreteFiscal={handleCloseHistoricoFreteFiscal}
				valoresHistoricoFreteFiscal={valoresHistoricoFreteFiscal}
				colunasFreteFiscalEmbarque={colunasFreteFiscalEmbarque}
				tabelaRedux={tabelaRedux}
				valoresHistorico={valoresHistorico}
				values={values}
				openHistoricoEdicao={openHistoricoEdicao}
				handleCloseHistoricoEdicao={handleCloseHistoricoEdicao}
				openProposta={openProposta}
				handleCloseProposta={handleCloseProposta}
				openMotivoOnTime={openMotivoOnTime}
				handleCloseMotivoOnTime={handleCloseMotivoOnTime}
				vincularMotivoOnTime={vincularMotivoOnTime}
				setMotivoId={setMotivoId}
				setNomeMotivo={setNomeMotivo}
				openMotivoCancelado={openMotivoCancelado}
				handleCloseMotivoCancelado={handleCloseMotivoCancelado}
				cancelarCarga={cancelarCarga}
				setMotivoId2={setMotivoId2}
				openCTE={openCTE}
				handleCloseCTE={handleCloseCTE}
				onSuccessDefinirCte={onSuccessDefinirCte}
				onErrorDefinirCte={onErrorDefinirCte}
				openStatus={openStatus}
				handleCloseStatus={handleCloseStatus}
				definirStatus={definirStatus}
				setStatus={setStatus}
				openEmbalagem={openEmbalagem}
				handleCloseEmbalagem={handleCloseEmbalagem}
				definirEmbalagem={definirEmbalagem}
				setEmbalagem={setEmbalagem}
				openMercadoria={openMercadoria}
				handleCloseMercadoria={handleCloseMercadoria}
				definirMercadoria={definirMercadoria}
				setMercadoria={setMercadoria}
				openVeiculo={openVeiculo}
				handleCloseVeiculo={handleCloseVeiculo}
				definirVeiculo={definirVeiculo}
				setVeiculo={setVeiculo}
				setMotorista={setMotorista}
				openMeioPagamento={openMeioPagamento}
				handleCloseMeioPagamento={handleCloseMeioPagamento}
				definirMeioPagameto={definirMeioPagameto}
				setMeioPagamento1={setMeioPagamento1}
				setMeioPagamento2={setMeioPagamento2}
				openAlterarDatas={openAlterarDatas}
				setOpenAlterarDatas={setOpenAlterarDatas}
				handleOnSuccessEditarDatas={handleOnSuccessEditarDatas}
				odenConfig={odenConfig}
				handleCloseConfig={handleCloseConfig}
				tabelaUsuario={tabelaUsuario}
				openEmbarque={openEmbarque}
				handleCloseEmbarque={handleCloseEmbarque}
				openAlterarUnidadeEmbarque={openAlterarUnidadeEmbarque}
				handleCloseAlterarUnidadeEmbarque={handleCloseAlterarUnidadeEmbarque}
				openInsightsViagem={openInsightsViagem}
				handleCloseInsightsViagem={handleCloseInsightsViagem}
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
			<ToastAviso
				texto={textoAviso}
				open={openToastAviso}
				onClose={handleCloseToastAviso}
			/>
		</Layout>
	);
}
export default Embarque;
